import React, { useContext } from "react";
import { StationContext } from "../../contexts";
import locale from "../../localization";
import { Intro } from "../../components/commons";
import Title from "../../components/commons/title/title";
import QrGenerator from "../../components/commons/qr-generator/qr-generator";
import QrDocumentGenerator from "../../components/commons/qr-generator/qr-document-generator";

import styles from "./generate-qr.module.scss";

const GenerateQrModule = () => {
  const { station } = useContext(StationContext);
  const availableProducts = Object.entries(station.stationProduct)
    .filter(([, id]) => id === true)
    .map(([key, _]) => key);
  let lubricantStations = [];
  let seagasStations = [];
  let seachargeStations = [];
  if (station.allMerchants) {
    lubricantStations = station.allMerchants.filter((item) => item.businessName === "Lubricants");
    seagasStations = station.allMerchants.filter((item) => item.businessName === "SEAGAS");
    seachargeStations = station.allMerchants.filter((item) => item.businessName === "SEAcharge");
  }

  const qrUpdatedAt = station.qrUpdatedAt;
  const dataList = availableProducts
    .filter((item) => !["lubes", "seacharge", "seagas"].includes(item))
    .map((data) => {
      console.log("data", data);
      const qrObject = {
        fuelType: data,
        stationId: `${station.stationCode}`,
        stationName: station.name,
        qrId: station.qrId,
      };
      let desc;
      if (data === "lubes") {
        desc = "Lubricants";
      } else if (data === "gas91") {
        desc = "Gas 91";
      } else if (data === "gas97") {
        desc = "Gas 97";
      } else if (data === "gas95") {
        desc = "Gas 95";
      } else if (data === "diesel") {
        desc = "Diesel";
      }
      return {
        qr: qrObject,
        description: desc,
      };
    });
  if (station.merchant) {
    let qr = {
      qr: {
        merchantId:
          lubricantStations.length === 0
            ? station.merchant.merchantId
            : lubricantStations[0].merchantId,
        productType: "lubes",
        qrId: station.qrId,
      },
      description: "Lubricants",
    };
    dataList.push(qr);
  }

  if (seagasStations.length > 0) {
    dataList.push({
      qr: {
        merchantId: seagasStations[0].merchantId,
        productType: "seagas",
        qrId: station.qrId,
      },
      description: "SEAGAS",
    });
  }

  if (seachargeStations.length > 0) {
    dataList.push({
      qr: {
        merchantId: seachargeStations[0].merchantId,
        productType: "seacharge",
        qrId: station.qrId,
      },
      description: "SEAcharge",
    });
  }

  console.log("dataList", dataList);

  const QrCodeRow = () => {
    return dataList.map((data, index) => (
      <QrGenerator
        key={data.description + index}
        qrData={data.qr}
        description={data.description}
        useTemplate={false}
        qrUpdatedAt={qrUpdatedAt}
      />
    ));
  };
  const TemplatedQrCodes = () => {
    return dataList.map((data, index) => (
      <QrGenerator
        key={data.description + index}
        qrData={data.qr}
        description={station.name}
        useTemplate={true}
        qrUpdatedAt={qrUpdatedAt}
      />
    ));
  };

  const sectionBuilder = (name, button) => {
    return (
      <div className={styles.intro}>
        <div>
          <Title small className={styles.title} black={true}>
            {name}
          </Title>
        </div>
        <div>{button}</div>
      </div>
    );
  };

  return (
    <>
      <Intro title={locale.generateQrCode} />
      {sectionBuilder(
        locale.generic,
        <QrDocumentGenerator qrDataList={dataList} description={station.name} useTemplate={false} />
      )}
      <div className={styles.generateQrRow}>
        <QrCodeRow />
      </div>
      {sectionBuilder(
        locale.templated,
        <QrDocumentGenerator qrDataList={dataList} description={station.name} useTemplate={true} />
      )}
      <div className={styles.generateQrRow}>
        <TemplatedQrCodes />
      </div>
    </>
  );
};

export default GenerateQrModule;
